/**
 * CommuterScoreGauge component for Commercial PDP.
 * Renders an SVG-based circular donut gauge displaying the commuter score.
 * The filled arc length is proportional to the score (0-100).
 */
/* eslint-disable react/prop-types */
const CommuterScoreGauge = ({ score = 0, ratingTier = '', color = '#9ca3af' }) => {
  const size = 160;
  const strokeWidth = 12;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const fillLength = (score / 100) * circumference;
  const gapLength = circumference - fillLength;

  return (
    <div className="commuter-score-gauge">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="commuter-score-gauge__svg"
        aria-label={`Commuter score ${score} out of 100, rated ${ratingTier}`}
        role="img"
      >
        {/* Background track */}
        <circle
          className="commuter-score-gauge__track"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
        />
        {/* Filled arc */}
        <circle
          className="commuter-score-gauge__fill"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${fillLength} ${gapLength}`}
          strokeDashoffset={circumference * 0.25}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        {/* Score numeral at center */}
        <text
          className="commuter-score-gauge__score"
          x="50%"
          y="46%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="48"
          fontWeight="600"
          fontFamily="'graphikregular', sans-serif"
          fill="#000"
          style={{ lineHeight: '48px' }}
        >
          {score}
        </text>
        {/* Rating tier label below score */}
        <text
          className="commuter-score-gauge__tier"
          x="50%"
          y="64%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="14"
          fontWeight="400"
          fontFamily="'graphikregular', sans-serif"
          fill="#48525B"
          style={{ lineHeight: '21px' }}
        >
          {ratingTier}
        </text>
      </svg>
    </div>
  );
};

export default CommuterScoreGauge;
